import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import syncTemplatesService from '../services/syncTemplatesService';
import SyncTemplateGraphic from './SyncTemplateGraphic';
import './AdminSyncTemplates.css';
import './PaymentPorterPage.css';

const AdminSyncTemplates = () => {
    const navigate = useNavigate();
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteConfirm, setDeleteConfirm] = useState(null);

    useEffect(() => {
        syncTemplatesService.listTemplates()
            .then(data => setTemplates(data || []))
            .catch(err => setError(err.response?.data?.message || err.message || 'Failed to load'))
            .finally(() => setLoading(false));
    }, []);

    const handleDeleteConfirm = async () => {
        if (!deleteConfirm) return;
        try {
            await syncTemplatesService.deleteTemplate(deleteConfirm.id);
            setTemplates(prev => prev.filter(t => t.id !== deleteConfirm.id));
        } catch (err) {
            alert(err.response?.data?.message || 'Delete failed');
        } finally {
            setDeleteConfirm(null);
        }
    };

    if (loading) return <div className="ast-loading">Loading sync templates…</div>;

    return (
        <div className="ast-container">
            <div className="ast-header">
                <h1>Sync Templates</h1>
                <button className="pp-rules-add-btn" onClick={() => navigate('/admin/sync-templates/new')}>
                    <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                    New Template
                </button>
            </div>

            {error && <div className="ast-error">{error}</div>}

            <div className="ast-list">
                {templates.length === 0 && !error && (
                    <div className="ast-empty">No templates found.</div>
                )}
                {templates.map(t => (
                    <div key={t.id} className="ast-template-card">
                        <div className="ast-template-row">
                            <div className="ast-template-info">
                                <SyncTemplateGraphic template={t} compact />
                                <div className="ast-template-meta">
                                    <span className="ast-template-name">{t.name}</span>
                                    {t.code && <span className="ast-template-code">{t.code}</span>}
                                    <span className={`ast-badge ast-badge-${(t.status || 'ACTIVE').toLowerCase()}`}>{t.status || 'ACTIVE'}</span>
                                    {t.description && <span className="ast-template-desc-inline">{t.description}</span>}
                                </div>
                            </div>
                            <div className="ast-template-actions">
                                <button className="pp-criteria-add-btn pp-criteria-add-btn-primary" onClick={() => navigate(`/admin/sync-templates/${t.id}/edit`)}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" style={{flexShrink:0}}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                    Edit
                                </button>
                                <button className="pp-criteria-add-btn pp-criteria-add-btn-danger" onClick={() => setDeleteConfirm({ id: t.id, name: t.name })}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {deleteConfirm && (
                <div className="ast-modal-overlay">
                    <div className="ast-modal ast-modal-sm">
                        <h2>Delete Template</h2>
                        <p>Delete <strong>{deleteConfirm.name}</strong>?</p>
                        <div className="ast-modal-actions">
                            <button className="pp-back-btn" onClick={() => setDeleteConfirm(null)}>Cancel</button>
                            <button className="pp-criteria-add-btn pp-criteria-add-btn-danger" onClick={handleDeleteConfirm}>
                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminSyncTemplates;
